import { render, staticRenderFns } from "./Container.html?vue&type=template&id=635aa8be&scoped=true&external"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.css?vue&type=style&index=0&id=635aa8be&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635aa8be",
  null
  
)

export default component.exports